import axios from "axios";
// import jscookie from "js-cookie";
// import { Message } from "element-plus";
// import { handleSSOLogin } from "./sso-login";
import { getStoreToken } from "./token";
import { ElMessage } from "element-plus";
// function getUserAuth() {
//   try {
//     const jwtTokenSlave = jscookie.get("jwtTokenSlave");
//     const jwtTokenMaster = jscookie.get("jwtTokenMaster");
//     if (jwtTokenSlave && jwtTokenMaster) {
//       return jwtTokenMaster + "," + jwtTokenSlave;
//     } else {
//       return "";
//     }
//   } catch (err) {
//     return "";
//   }
// }

const service = axios.create({
  baseURL:
    process.env.NODE_ENV === "development" ? "" : process.env.VUE_APP_BASE_API, //
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    config.headers["Token"] = getStoreToken();
    config.headers["Client_id"] = process.env.VUE_APP_ClientID;
    //不是sso的请求增加一个头部
    if (config.url.indexOf(process.env.VUE_APP_SSO_URL) === -1) {
      config.headers["SsoClientId"] = process.env.VUE_APP_ClientID;
    }
    // 没有token登录页
    // if (!getStoreToken()) {
    // handleSSOLogin();
    //   return;
    // }

    // 开发环境写死
    if (process.env.NODE_ENV === "development") {
      config.headers["Token"] = "8a2ce49e6944091b75192d3be28af73c72221480";
      // config.headers["Authorization"] =
      //   "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJlZDI3ZGIxYTU5MmY0NDZkOGYzNDNhNTI1ZDI5ZDFkZCIsImlzcyI6IlpITCIsInJvbGVOYW1lIjoiYWRtaW5fdGFzayIsImN1cnJTeXN0ZW1GbGFnIjoiMiIsInN5c01vZGVsIjoyLCJleHAiOjE3NDUxMzM0NjMsImlhdCI6MTc0NTEyOTg2MywianRpIjoiZWU3YzQ1NGYtNjM4Ni00MmUyLTlmNDYtODA3YzBhN2UxMjE4In0.e7V5sQhfgc1huMGVwWcVc42cwZAerj6X3e_gzvvEZos,eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJlZDI3ZGIxYTU5MmY0NDZkOGYzNDNhNTI1ZDI5ZDFkZCIsImlzcyI6IlpITCIsInJvbGVOYW1lIjoiYWRtaW5fdGFzayIsImN1cnJTeXN0ZW1GbGFnIjoiMiIsInN5c01vZGVsIjoyLCJleHAiOjE3NDUxMzg4NjMsImlhdCI6MTc0NTEyOTg2MywianRpIjoiNGZlMTM4NTItZWQ0Zi00NTYyLTk3NzUtNTk2ZDg1ODc1MGFiIn0.YLLs5Iv5hsVrXzV2zTFMNtL9xMM9HQa7MjFU_YyJtkI";
    } else {
      // 测试环境从cookie中获取
      // config.headers["Authorization"] = getUserAuth();
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
service.interceptors.response.use(
  (response) => {
    if (response.data.code === 200 || !response.data.code) return response.data;
    if (response.data.code !== 200) {
      // window.alert(
      //   response.data.message ||
      //     response.data.msg ||
      //     response.data.errorMessage ||
      //     "接口异常"
      // );
      ElMessage.error(
        response.data.message ||
          response.data.msg ||
          response.data.errorMessage ||
          "接口异常"
      );
      // // 判断1011 401
      // if (response.data.code === 1011 || response.data.code === 401) {
      //   // 跳转登录页
      //   handleSSOLogin();
      // }
      return response.data;
    }
  },
  (err) => {
    if (err) {
      // window.alert(err.Message);
      ElMessage.error(err.Message);
      return Promise.reject(err);
    }
  }
);
// response interceptor

export default service;
